import { collectDiagnostics, required } from "./validationUtils.js";
export function validateConfigurationAction(payload: Record<string, unknown>) { return collectDiagnostics(required(payload.tenantId, "tenantId", "Tenant"), required(payload.reason, "reason", "Reason/comment")); }
